import LoginForm from './components/LoginForm'
import RegisterForm from './components/RegisterForm'
import PasswordChangeForm from './components/PasswordChangeRequestForm'
import type { RegisterPageState } from './utils/types'

import MarginBox from '../../shared/components/other/MarginBox';
import { useState } from 'react';
import Navbar from '../../shared/components/navbar/NavBar';

interface LoginProps {
  initialPage?: RegisterPageState
}

export default function Login({ initialPage = "login" }: LoginProps) {

  const [registerPageState, setRegisterPageState] = useState<RegisterPageState>(initialPage)

  const forms = {
    "login": (
      <LoginForm registerPageState={registerPageState} setRegisterPageState={setRegisterPageState} />),

    "password-change": (
      <PasswordChangeForm registerPageState={registerPageState} setRegisterPageState={setRegisterPageState} />),

    "register": (
      <RegisterForm registerPageState={registerPageState} setRegisterPageState={setRegisterPageState} />)
  }

  const lForm = forms[registerPageState];

  return (
    <MarginBox wrapperClassName="loginWrapper">
      <Navbar/>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url(./loginPanelBackground.png)",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(30px)',
          zIndex: 0
        }}
      />
      {lForm}
    </MarginBox>
  );
}